var __jsx = React.createElement;
import React from "react";
import CarSaleCardCarousel from "./CarSaleCardCarousel";
import bgImage from "../icons/bg.svg";
import { CarSaleCardSkeleton } from "./CarSaleCardSkeleton";
var DesktopHeroLayout = function DesktopHeroLayout(_ref) {
  var data = _ref.data,
    isLoading = _ref.isLoading,
    sellTradeItems = _ref.sellTradeItems,
    autoPlay = _ref.autoPlay,
    autoPlayInterval = _ref.autoPlayInterval,
    onBookAppointment = _ref.onBookAppointment,
    onSlideChange = _ref.onSlideChange,
    onRefetch = _ref.onRefetch;
  return /*#__PURE__*/React.createElement("div", {
    id: "desktop-hero-layout",
    className: "hidden md:block"
  }, /*#__PURE__*/React.createElement("div", {
    id: "desktop-hero-background-section",
    className: "relative w-full px-10 mt-12"
  }, /*#__PURE__*/React.createElement("div", {
    id: "desktop-hero-background-container",
    className: "overflow-hidden rounded-3xl"
  }, /*#__PURE__*/React.createElement("img", {
    id: "desktop-hero-background-image",
    src: bgImage,
    alt: "Background",
    className: "w-full h-[560px] object-cover"
  })), /*#__PURE__*/React.createElement("div", {
    id: "desktop-hero-content",
    className: "absolute inset-0 flex flex-col items-center pt-16 pb-32 z-10"
  }, /*#__PURE__*/React.createElement("h1", {
    id: "desktop-hero-title",
    className: "text-primary-new text-[64px] font-bold text-center mb-6"
  }, function () {
    var firstDotIndex = data.label1.indexOf(".");
    if (firstDotIndex === -1) {
      return data.label1;
    }
    var firstLine = data.label1.substring(0, firstDotIndex + 1);
    var secondLine = data.label1.substring(firstDotIndex + 1).trim();
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      id: "desktop-hero-title-line-1",
      className: "block md:my-5"
    }, firstLine), /*#__PURE__*/React.createElement("span", {
      id: "desktop-hero-title-line-2"
    }, secondLine));
  }()), data.label2 && /*#__PURE__*/React.createElement("p", {
    id: "desktop-hero-subtitle",
    className: "text-gray-700 text-[32px] font-semibold text-center mt-10 mb-8"
  }, data.label2))), /*#__PURE__*/React.createElement("div", {
    id: "desktop-hero-carousel-section",
    className: "relative px-10 pb-20",
    style: {
      marginTop: '-200px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "desktop-hero-carousel-container",
    className: "relative z-20"
  }, isLoading && /*#__PURE__*/React.createElement(CarSaleCardSkeleton, null), !isLoading && sellTradeItems.length > 0 && /*#__PURE__*/React.createElement(CarSaleCardCarousel, {
    cards: sellTradeItems,
    autoPlay: autoPlay,
    autoPlayInterval: autoPlayInterval,
    onBookAppointment: onBookAppointment,
    onSlideChange: onSlideChange,
    onRefetch: onRefetch
  }))));
};
export default DesktopHeroLayout;